import { useRef } from "react";

const LogConfig = () => {
    useRef(
        (() => {
            if (
                window.location.hostname === "tanesw.tra.go.tz" ||
                window.location.hostname === "tanoga.tra.go.tz" ||
                window.location.hostname === "ntancis.tra.go.tz"
            ) {
                window.console.log = () => {};
            }
        })(),
    );

    return null;
};

export default LogConfig;
